module.exports = __webpack_public_path__ + "static/media/hotstareye.0af72e37.svg";